




import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import IFormModel from "@/models/IFormModel";

@Component
export default class AsiDialogForm extends Vue {

	@Prop({type: Boolean, required: true})
	public open!: boolean;

	protected loading: boolean = false;
	protected valid: boolean = false;
	protected errors: string[] = [];
	protected icons = Icon;

	protected reset(models: IFormModel[] = [], form: HTMLFormElement | null = null): void {
		this.valid = true;
		this.errors = [];
		models.forEach(m => m.reset());

		if (form !== null) {
			form.resetValidation();
		}
	}
}
